import { syncRarity } from "./wtg";

export default async function sync(contractAddress, data) {
  return syncRarity(contractAddress, data);
};
